import { useApi, useAuth } from '../../hooks';
import { useQuery } from '@tanstack/react-query';
import { MedicationOption } from '../types';

export const useMedicationOptions = (search?: string) => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchMedicationOptions = async () => {
    const requestObj = {
      route: `/private/dashboard/medications?search=${encodeURIComponent(
        search ?? ''
      )}`,
      token: userToken,
    };

    return await api(requestObj);
  };

  const { data, isLoading, isError } = useQuery<MedicationOption[], Error>({
    queryKey: ['medications', userToken, search],
    queryFn: () => fetchMedicationOptions(),
    enabled: isAuthenticated && !loading && !!userToken && !!search,
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, isError };
};
